import { lazy } from "react";
import IRoute from "./IRoute";

// Admin dashboard is the heaviest single page in the app (user management
// tables, photo upload, endpoint telemetry, bankroll-reset queue).
// Lazy-loading keeps it out of the bundle entirely for the 99% of
// users who aren't admins.
const AdminDashboard = lazy(() => import("../pages/Admin/AdminDashboard"));

const adminRoutes: IRoute = {
  path: "/admin",
  redirect: "/admin/dashboard",
  children: [
    {
      path: "/dashboard",
      component: AdminDashboard,
      needAuth: true,
      role: "Admin",
    },
  ],
  role: "Admin",
};

export default adminRoutes;
